import {
	CreateSliceOptions,
	SliceCaseReducers,
	createSlice as createReduxSlice,
} from '@reduxjs/toolkit';

export const createSlice = <
	State,
	CaseReducers extends SliceCaseReducers<State>,
	Name extends string = string,
>(
	options: CreateSliceOptions<State, CaseReducers, Name>,
) => {
	const wrapperReducers = {
		resetSlice: () => options.initialState,
	};

	return createReduxSlice({
		...options,
		reducers: {
			...wrapperReducers,
			...options.reducers,
		} as typeof wrapperReducers & typeof options.reducers,
	});
};

export const resetStore = () => ({ type: 'resetStore' });
